export const CART_ROUTE_NAME = "Cart";
export const DEFAULT_DEBOUNCE_IN_MS = 300;
export const EXTENDED_DEBOUNCE_IN_MS = 1000;
export const DEFAULT_ITEMS_FOR_LATER_WISHLIST = "__itemsForLater";
export const DEFAULT_NOTIFICATIONS_WISHLIST = "__notifications";
export const DEFAULT_VISIBLE_ITEMS_IN_ITEMS_FOR_LATER = 3;
